module.exports = __webpack_public_path__ + "static/media/pf.91cad8fe.webp";